module.exports = __webpack_public_path__ + "static/media/game(19).ebe8c714.PNG";